import { IPersonnelGroup } from "@/customTypings/PersonnelGroup";
import { authHeader, handleResponse } from "../helpers";
import { ITaskCategory } from "@/customTypings/TaskCategory";

export const personnelGroupService = {
    getAllListItems,
    get,
    addPersonnelGroup,
    editPersonnelGroup,
    getAll
};

function getAllListItems() {
    const requestOptions = { method: "POST", headers: authHeader() };
    return fetch(`api/personnelgroup/alllistitems`, requestOptions).then(handleResponse);
}

function get(groupId: string) {
    const requestOptions: RequestInit = {
        method: "GET",
        credentials: "include",
        headers: authHeader(),
    };
    return fetch(`api/personnelgroup/get/${groupId}`, requestOptions)
        .then(handleResponse)
        .then((response) => {
            return response;
        });
}

function addPersonnelGroup(taskCategory: ITaskCategory) {
    const requestOptions: RequestInit = {
        method: "POST",
        credentials: "include",
        headers: authHeader(),
        body: JSON.stringify(taskCategory),
    };
    return fetch(`api/personnelgroup/createpersonnelgroup`, requestOptions)
        .then(handleResponse)
        .then((response) => {
            return response;
        });
}

function editPersonnelGroup(group: IPersonnelGroup) {
    const requestOptions: RequestInit = {
        method: "PATCH",
        credentials: "include",
        headers: authHeader(),
        body: JSON.stringify(group),
    };
    return fetch(`api/personnelgroup/edit`, requestOptions)
        .then(handleResponse)
        .then((response) => {
            return response;
        });
}
function getAll() {
    const requestOptions: RequestInit = {
        method: 'GET',
        headers: authHeader(),
        credentials: 'include',
    };

    return fetch(`api/personnelgroups/all`, requestOptions)
        .then(handleResponse);
}
